import { defineComponent as A, useAttrs as N, ref as C, watch as x, onMounted as j, onUpdated as D, unref as a, openBlock as n, createElementBlock as s, normalizeClass as p, Fragment as I, createBlock as c, createCommentVNode as u, createElementVNode as b, toDisplayString as M, createVNode as d, withCtx as E, normalizeStyle as H } from "vue";
import P from "../tooltip-layout/tooltip-layout.vue.js";
import m from "../sequiter-markdown/sequiter-markdown.vue.js";
import k from "../sequiter-image/sequiter-image.vue.js";
import { ICONS as V } from "../sequiter-image/icon-library.js";
import { newImageModel as z } from "../sequiter-image/image-model.js";
import { TEXT_DISPLAY_VARIANTS as i } from "./text-display-variants.js";
import { DIALOG_VARIANTS as F } from "../dialog-layout/dialog-layout-variants.js";
import $ from "../shimmer/shimmer.vue.js";
import { LoadingStateManager as B } from "../../loading-state/loading-state-manager.js";
import { ComponentSetupError as L } from "../../errors/component-setup-error.js";
import { LoadingStateInjectionFacade as U } from "../../injection/loading-state-injection-facade.js";
import { ErrorLoggerInjectionFacade as q } from "../../injection/error-logger-injection-facade.js";
const Y = { class: "text-content" }, G = { key: 0 }, re = /* @__PURE__ */ A({
  name: "text-display",
  __name: "text-display",
  props: {
    /**
     * The variant of the text display
     */
    variant: {
      type: String,
      default: i.STANDARD,
      validator: (e) => Object.values(i).includes(e)
    },
    /**
     * The primary text to display
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * The title for the text, only supported for @see {@link TEXT_DISPLAY_VARIANTS.INFO_DESCRIPTOR}.
     */
    title: {
      type: String,
      default: null
    },
    /**
     * The text to display in the hovered portion. Only supported for @see {@link TEXT_DISPLAY_VARIANTS.HOVER_HELP}
     */
    hoverText: {
      type: String
    },
    /**
     * The image model object, only supported for @see {@link TEXT_DISPLAY_VARIANTS.INFO_DESCRIPTOR} or @see {@link TEXT_DISPLAY_VARIANTS.HOVER_HELP}
     */
    image: {
      type: Object
    }
  },
  setup(e) {
    const f = e;
    function R(t) {
      return z(
        t?.src ?? V.QUESTION_MARK_CIRCLE,
        t?.alt ?? "More Information",
        t?.title ?? ""
      );
    }
    const S = new U().useInjection(), r = new B({ width: 100, height: 55 }), O = N(), T = r.getLoadingState(), h = r.getShimmerSize(), g = C({}), v = new q().useInjection();
    x(S, (t) => {
      r.setLoadingState(t);
    }), x(
      () => [f.variant, f.hoverText],
      ([t, o]) => {
        t && t === i.HOVER_HELP && !o && v.logError(
          new L(
            "text-display",
            `'variant' specified as '${t}', but no 'hoverText' was specified.`
          )
        );
      },
      { immediate: !0 }
    );
    function y() {
      O.content && v.logError(
        new L(
          "text-display",
          "'content' prop is deprecated, use 'text' instead"
        )
      );
    }
    j(() => {
      g.value && (r.calculateShimmerSize(g.value), r.setLoadingState(S.value)), y();
    });
    const w = (t) => {
      if (t.target) {
        const o = document.createRange();
        o.selectNodeContents(t.target);
        const l = window.getSelection();
        return l?.removeAllRanges(), l?.addRange(o), l?.toString() || "";
      }
      return "";
    };
    return D(y), (t, o) => a(T) ? (n(), c($, {
      key: 1,
      class: p([`${t.$options.name}-shimmer`]),
      style: H([
        { width: a(h).width + "px" },
        { "min-height": a(h).height + "px" }
      ])
    }, null, 8, ["class", "style"])) : (n(), s("div", {
      key: 0,
      ref_key: "containerRef",
      ref: g,
      class: p([t.$options.name, e.variant, { "has-icon": e.image !== void 0 }])
    }, [
      e.variant === a(i).INFO_DESCRIPTOR ? (n(), s(I, { key: 0 }, [
        e.image !== void 0 ? (n(), c(k, {
          key: 0,
          imageObj: e.image,
          role: "presentation"
        }, null, 8, ["imageObj"])) : u("", !0),
        b("section", Y, [
          e.title !== null ? (n(), s("header", G, M(e.title), 1)) : u("", !0),
          d(m, { content: e.text }, null, 8, ["content"])
        ])
      ], 64)) : e.variant === a(i).HOVER_HELP ? (n(), s(I, { key: 1 }, [
        d(m, {
          class: "hover-target",
          content: e.text
        }, null, 8, ["content"]),
        e.hoverText ? (n(), c(P, {
          key: 0,
          "popper-triggers": ["hover"],
          shift: !1,
          variant: a(F)._HOVER_HELP
        }, {
          content: E(() => [
            d(m, {
              class: "hover-text",
              content: e.hoverText
            }, null, 8, ["content"])
          ]),
          default: E(() => [
            d(k, {
              class: "hover-target-img",
              imageObj: R(e.image),
              role: "presentation"
            }, null, 8, ["imageObj"])
          ]),
          _: 1
        }, 8, ["variant"])) : u("", !0)
      ], 64)) : e.variant === a(i).READ_ONLY_INPUT ? (n(), c(m, {
        key: 2,
        onClick: o[0] || (o[0] = (l) => w(l)),
        content: e.text
      }, null, 8, ["content"])) : (n(), c(m, {
        key: 3,
        content: e.text
      }, null, 8, ["content"]))
    ], 2));
  }
});
export {
  re as default
};
//# sourceMappingURL=text-display.vue2.js.map
